import { Expose } from "class-transformer";

export class ProductSearchHitDto {
  @Expose()
  uniqueIdentifier!: string;
}
